
import HomeTrendDown from "../../../assets/duotone/HomeTrendDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HomeTrendDownIcon({ className, dataTestid = "HomeTrendDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HomeTrendDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
